import React from 'react';

import { ReactComponent as IconAirplaneBeachPalm } from 'media/svg/airplaneBeachPalm.svg';

import styles from './Card.module.scss';

export interface CardProps {
    isLoading?: boolean;
}

const Card = ({ isLoading = true }: CardProps) => {
    return (
        <article
            className={`${styles.Card} ${isLoading ? styles.Loading : ''}`}
        >
            <aside>
                <IconAirplaneBeachPalm />
            </aside>
            <header>
                <div className={styles.Heading}>
                    <div />
                    <div>&nbsp;•&nbsp;</div>
                </div>
                <div className={styles.Rating} />
            </header>
            <div className={styles.Badges}>
                <hr />
            </div>
            <div className={styles.Meta}>
                <div />
                <div />
            </div>
            <div className={styles.OfferInfo} />
        </article>
    );
};

export default Card;
